class CheckoutInputPrice extends React.Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    onChange(e) {
        if (!this.props.ignoreValidation) {
            var self = this;
            var str = e.target.value.replace(/^0+/, '').replace(/[^0-9.]/g, '');
            var int = 0;
            var parts;

            if (str.length > 0) {
                if (str.indexOf('.') !== -1) {
                    parts = str.split('.');

                    if (parts.length > 2) {
                        return;
                    }

                    if (parts[1].length > 2) {
                        return;
                    }

                    var dollar = parts[0] > 0  ? parseInt(parts[0]) * 100 : 0;
                    var cent   = 0;

                    if (parts[1].length === 1) {
                        cent = parts[1] * 10;
                    } else if (parts[1].length === 2) {
                        cent = parts[1];
                    }

                    int = parseInt(dollar) + parseInt(cent);

                } else {
                    int = parseInt(str) * 100;
                }
            }

            this.props.onChange({
                str : str,
                int : int
            })
        } else {
            this.props.onChange( e.target.value );
        }
    }

    onBlur(type) {
        if (!this.props.ignoreValidation) {
            var val = this.props.value.str;

            if (val.indexOf('.') !== -1) {
                val = val.split('.');

                if (val[0].length === 0) {
                    val[0] = '0';
                }

                if (val[1].length === 0) {
                    val[1] = '00';
                }

                if (val[1].length === 1) {
                    val[1] = val[1]+'0';
                }

                this.props.onChange({
                    str : val[0]+'.'+val[1],
                    int : this.props.value.int
                })
            }
        }
    }

    render() {
        var self = this;
        return (
            <div className='checkout-input'>

                { this.props.title &&
                    <div className='checkout-input__title'>
                        {this.props.title}
                    </div>
                }

                { this.props.icon &&
                    <i className={'fa fa-'+this.props.icon+' checkout-input__icon'} />
                }

                { this.props.hypur &&
                    <img
                        src='/assets/hypur-logo-small.png'
                        className='checkout-input__hypur' />
                }

                <input className={(this.props.isRequired ? 'checkout-input__required' : '')}
                    disabled={this.props.disabled}
                    style={{
                        position: 'absolute',
                        width: '130px',
                    }}
                    type='text'
                    value={this.props.value.str}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    placeholder={this.props.placeholder || '0.00'} />
            </div>
        );
    }
}

export default CheckoutInputPrice;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/CheckoutInputPrice.react.jsx